import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SwUpdate } from '@angular/service-worker';
import { environment } from 'src/environments/environment';
import { PwaInstallationDialogComponent } from '../../components/pwa-installation-dialog/pwa-installation-dialog.component';
import { PlatformEnum } from '../../enums/platform.enum';
import { DeviceService } from '../device/device.service';

@Injectable({
  providedIn: 'root',
})
export class PwaService {
  deferredPrompt;

  constructor(
    private swUpdate: SwUpdate,
    private dialog: MatDialog,
    private deviceService: DeviceService
  ) {
    if (this.deviceService.isMobileDevice()) {
      return;
    }

    if (!environment.PWA_ENABLED) {
      return;
    }

    // intercetta quando è disponibile un nuovo aggiornamento e lo attiva in background,
    // senza reload forzato: la build nuova verrà servita al prossimo refresh manuale dell'utente
    this.swUpdate.checkForUpdate().then(checkForUpdate => {
      if (checkForUpdate) {
        this.swUpdate.activateUpdate();
      }
    });

    const pwaInstallationDenied = JSON.parse(localStorage.getItem('pwainstallationdenied'));
    if (!pwaInstallationDenied) {
      // intercetta la richiesta di installazione della pwa
      window.addEventListener('beforeinstallprompt', e => {
        e.preventDefault();
        this.deferredPrompt = e;
        this.openPwaInstallationDialog();
      });
    }
  }

  openPwaInstallationDialog() {
    const dialogRef = this.dialog.open(PwaInstallationDialogComponent, {
      data: {},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.triggerAddToHomeScreen();
      } else {
        localStorage.setItem('pwainstallationdenied', JSON.stringify(true));
      }
    });
  }

  triggerAddToHomeScreen() {
    // richiede l'installazione della pwa
    this.deferredPrompt.prompt();
    // attende che l'utente accetti l'installazione
    this.deferredPrompt.userChoice.then(choiceResult => {
      if (choiceResult.outcome === 'accepted') {
        alert("L'installazione di Check si è conclusa con successo!");
      } else {
        alert("Hai rifiutato l'installazione di Check.");
      }
      this.deferredPrompt = null;
    });
  }

  detectMobileOS() {
    const userAgent = navigator.userAgent || navigator.vendor;
    if (/android/i.test(userAgent)) {
      return PlatformEnum.android;
    }
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      return PlatformEnum.ios;
    }
    return PlatformEnum.web;
  }
}
